# Used by onboarding and most of the other products
# Handles modal windows for additional details. Can present either a given content or a PDF file

currentModal = null

closeModal = ->
  if currentModal
    currentModal.remove()
    currentModal = null
  $('body').removeClass 'body--modal'

backModal = ->
  window.history.back()

pushHistoryEntry = (source) ->
  history.pushState { modal: source }, source

composeModal = (title, type, content = '') ->
  $modal = $ '<div/>'
  $d     = $('<div/>', class: 'modal-dimmer').on 'click', backModal
  $w     = $ '<div/>', class: 'modal-wrapper'
  $w.append '<div class="modal-header"><div class="modal-close"></div><h1></h1></div><div class="modal-content"></div>'
  $w.find('.modal-close').text($CAM.t('common', 'close')).on 'click', backModal
  $w.find('h1').text title
  $w.find('.modal-content').html(content) if content.length
  $w.addClass "modal-wrapper--#{type}"
  modal = $modal.append($d).append($w).children()
  $('body').append(modal).addClass 'body--modal'
  modal

createDefaultModal = (title, type, source) ->
  content = $(source).html() || $CAM.t('common', 'no_content')
  composeModal title, type || 'default', content

createPdfModal = (title, source) ->
  unless PDFObject.supportsPDFs
    window.open source, '_blank'
    return null
  error = $CAM.t('common', 'embed_error')
  modal = composeModal title, 'pdf'
  PDFObject.embed source,
     modal.find('.modal-content').get(0),
     fallbackLink: "<a href=\"#{source}\" target=\"_blank\">#{error}</a>"
  modal

createModal = (title, type, source) ->
  return createPdfModal(title, source) if type == 'pdf'
  return createDefaultModal(title, type, source)

$(document).on 'keyup', (ev) ->
  backModal() if currentModal && ev.keyCode == 27

$(document).on 'click', '[data-modal]', (ev) ->
  ev.stopPropagation()
  ev.preventDefault()
  $a = $ @
  currentModal = createModal @title, $a.data('modal'), $a.attr('href')
  console.log('modal!')
  pushHistoryEntry(@href) if currentModal

window.onpopstate = -> closeModal()

$(document).ready ->
  $('[data-modal][data-modal!="pdf"]').each -> $($(@).attr('href')).hide()
